import { useExtensionObjects } from "../ExtensionProvider";
const trueFunc = () => true;
const emptyFunc = () => ({});
const registerMainPage = (_instanceGroup, extInfo, icon, title, component, options) => {
    return {
        id: options.id || title,
        icon,
        mdi: options.mdi,
        title,
        component,
        propsFunc: options.props || emptyFunc,
        visible: options.visible || trueFunc,
        group: options.group,
        isClassicOnly: options.isClassicOnly,
        isModernOnly: options.isModernOnly,
        badge: options.badge,
        activity: options.activity,
        priority: options.priority !== undefined ? options.priority : 100,
        onReset: options.onReset,
        namespace: extInfo.namespace,
    };
};
export const useMainPages = () => {
    return useExtensionObjects(registerMainPage, undefined, undefined, true);
};
